import { Box, Typography } from "@mui/material";
import { forwardRef } from "react";

const ITEM_SX = {
  px: 0.5,
  cursor: "pointer",
  borderRadius: "6px",
  display: "flex",
  alignItems: "center",
  width: "100%",
  "&:hover": { bgcolor: "var(--color-light-dust)" },
} as const;

export interface ExportDropdownProps {
  onClose: () => void;
  onExportCsv?: () => void;
  onRedemptionReport?: () => void;
  onImpactReport?: () => void;
  onThankYouMessages?: () => void;
}

export const MenuTypography = ({ label }: { label: string }) => {
  return (
    <Typography
      sx={{
        fontWeight: 500,
        fontSize: 14,
        lineHeight: "20px",
        color: "var(--color-graphite)",
      }}
    >
      {label}
    </Typography>
  );
};

const ExportDropdown = forwardRef<HTMLDivElement, ExportDropdownProps>(
  ({ onClose, onExportCsv, onRedemptionReport, onImpactReport, onThankYouMessages }, ref) => {
    function handleOption(handler?: () => void) {
      handler?.();
      onClose();
    }

    return (
      <Box
        ref={ref}
        sx={{
          bgcolor: "white",
          border: "1px solid var(--color-dark-dust)",
          borderRadius: "10px",
          boxShadow: "0px 4px 6px -1px rgba(0,0,0,0.1), 0px 2px 4px -2px rgba(0,0,0,0.1)",
          p: "12px",
          width: 220,
          display: "flex",
          flexDirection: "column",
          mt: "6px",
        }}
      >
        {/* Export as CSV */}
        <Box onClick={() => handleOption(onExportCsv)} sx={{ ...ITEM_SX, height: 34 }}>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: 11,
              letterSpacing: "1.98px",
              textTransform: "uppercase",
              color: "var(--color-graphite)",
              lineHeight: 1,
            }}
          >
            Export as CSV
          </Typography>
        </Box>

        {/* Redemption Report */}
        <Box onClick={() => handleOption(onRedemptionReport)} sx={{ ...ITEM_SX, height: 34 }}>
          <MenuTypography label="Redemption Report" />
        </Box>

        {/* Impact Report */}
        <Box sx={{ p: "4px", width: "100%" }}>
          <Box onClick={() => handleOption(onImpactReport)} sx={{ ...ITEM_SX, py: "6px" }}>
            <MenuTypography label="Impact Report" />
          </Box>
        </Box>

        {/* Thank You Messages */}
        <Box sx={{ p: "4px", width: "100%" }}>
          <Box onClick={() => handleOption(onThankYouMessages)} sx={{ ...ITEM_SX, py: "6px" }}>
            <MenuTypography label="Thank You Messages" />
          </Box>
        </Box>
      </Box>
    );
  },
);

ExportDropdown.displayName = "ExportDropdown";
export default ExportDropdown;
